import { current } from "@reduxjs/toolkit";
import { isAdmin } from "src/Common/function";
import api from "./api";
import UserService from "./user.service";

//This function is for admin
const sendWOReport = (
  branchId,
  recipients,
  all,
  past7Days,
  past30Days,
  customDays,
  customStartDate,
  customEndDate,
  date,
  type
) => {
  return api.post("/api/wo/send_wo_report", {
    branchId,
    recipients,
    all,
    past7Days,
    past30Days,
    customDays,
    customStartDate,
    customEndDate,
    date,
    type,
  });
};

const sendHoursWorkedReport = (
  branchId,
  recipients,
  past7Days,
  past30Days,
  customDays,
  customStartDate,
  customEndDate,
  date
) => {
  return api.post("/api/report/send_hours_worked_report", {
    branchId,
    recipients,
    past7Days,
    past30Days,
    customDays,
    customStartDate,
    customEndDate,
    date,
  });
};

const create = (data) => {
  return api.post("/api/report/create", data);
};

const getAll = (branch) => {
  // let currentUser = UserService.getCurrentUser();
  // let branchId = branch;
  // if (!isAdmin()) {
  //   branchId = currentUser.branches[0].id;
  // }
  return api.get("/api/report/get_all", { params: { branchId: branch } });
};

const deleteReport = (id) => {
  return api.get("/api/report/delete", { params: { id } });
};

const update = (id, data) => {
  return api.post("/api/report/update", { id, data });
};

const ReportService = {
  sendWOReport,
  sendHoursWorkedReport,
  create,
  getAll,
  deleteReport,
  update,
};

export default ReportService;
